<template>
    <header class="header-wrapper">
        <slot />
    </header>
</template>

<style lang="scss" scoped>
    @use '@/assets/scss/imports';

    .header-wrapper {
        height: 54px;
        display: flex;
        align-items: center;
        color: imports.$color-gray-00;
        padding: 0 2 * imports.$margin-default;
        background: var(--tenancy-primary-color);
        box-shadow: inset 0 -3px 10px 0 rgba(var(--tenancy-primary-color), 0.3);
        justify-content: center;
        z-index: 20;

        @include imports.breakpoint-up(md) {
            justify-content: space-between;
            height: 80px;
            padding: 0 5 * imports.$margin-default;
        }
    }
</style>
